import styles from './CustomCode.module.css';

import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Checkbox, Card, Spin, PageHeader, Button, List } from 'antd';

import { ReloadOutlined } from '@ant-design/icons';

import { getFormsWithCustomCode, markFormWithCustomCodeAsChecked } from 'store/ducks/customCode.js';

const isFormCustomCodeChecked = (form) => {
  const customHeadCodeVersion = form.customHeadCodeVersion || 0;
  const customHeadCodeCheckedVersion = form.customHeadCodeCheckedVersion;

  return customHeadCodeCheckedVersion && customHeadCodeCheckedVersion === customHeadCodeVersion;
};

const CustomCode = () => {
  const dispatch = useDispatch();

  const customCodeForms = useSelector((state) => state.customCode.customCodeForms);
  const loadingForms = useSelector(
    (state) => state.customCode.getFormsWithCustomCode.loading || state.customCode.markFormWithCustomCodeAsChecked.loading
  );

  const reload = () => {
    dispatch(getFormsWithCustomCode());
  };

  useEffect(() => {
    dispatch(getFormsWithCustomCode());
  }, []);

  const [hideChecked, setHideChecked] = useState(true);

  const onChangeHideChecked = (e) => {
    setHideChecked(e.target.checked);
  };

  const filteredCustomCodeForms = useMemo(() => {
    if (hideChecked) {
      return customCodeForms.filter((form) => {
        return !isFormCustomCodeChecked(form);
      });
    } else {
      return customCodeForms;
    }
  }, [customCodeForms, hideChecked]);

  const handleMarkCustomCodeAsChecked = (formId) => {
    dispatch(markFormWithCustomCodeAsChecked(formId));
  };

  console.log(filteredCustomCodeForms);

  return (
    <>
      <PageHeader
        title="Custom Code Forms"
        extra={[
          <Button onClick={() => reload()}>
            <ReloadOutlined />
          </Button>,
          <Checkbox onChange={onChangeHideChecked} checked={hideChecked}>
            Hide checked
          </Checkbox>
        ]}
        style={{ border: '1px solid #f0f0f0', background: '#fff', margin: '0 0 15px 0' }}
      />

      <Spin spinning={loadingForms} size="large">
        <Card style={{ width: '100%' }}>
          <List
            itemLayout="vertical"
            dataSource={filteredCustomCodeForms}
            renderItem={(item) => (
              <List.Item key={item._id}>
                <div className={styles.item}>
                  <div className={styles.itemHeader}>
                    <div className={styles.titleAndBadges}>
                      <Link to={`/forms/${item._id}`} target="_blank">
                        {item.name}
                      </Link>
                      {item.status && (
                        <div className={styles.status} data-status={item.status}>
                          {item.status.toUpperCase()}
                        </div>
                      )}
                    </div>
                    <div className={styles.formOwner}>
                      <Link to={`/users/${item.owner._id}`} target="_blank">
                        {item.owner.email}
                      </Link>
                    </div>
                  </div>

                  <pre className={styles.customHeadCode}>{item.customHeadCode}</pre>

                  <div className={styles.itemHeaderSecondary}>
                    {isFormCustomCodeChecked(item) ? (
                      <>
                        <div className={styles.checkStatus}>{'✅ CHECKED'}</div>
                      </>
                    ) : (
                      <>
                        {String(item.customHeadCode).toLocaleLowerCase().includes('script') && (
                          <div className={styles.checkStatus}>⚡ SCRIPT</div>
                        )}
                        <div className={styles.checkStatus}>{'❌ NOT CHECKED'}</div>
                        <Button onClick={() => handleMarkCustomCodeAsChecked(item._id)}>Mark as checked</Button>
                      </>
                    )}
                    <div style={{ width: 10, marginRight: 'auto' }} />
                    <div>Version:{String(item.customHeadCodeVersion)}</div>
                    <div>CheckedVersion:{String(item.customHeadCodeCheckedVersion)}</div>
                  </div>
                </div>
              </List.Item>
            )}
          />
        </Card>
      </Spin>
    </>
  );
};

export default CustomCode;
